import PropTypes from "prop-types";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { mainListItems, moreListItems, sairListItems } from "./Menu";
import {
  Box,
  Divider,
  List,
  styled,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import MuiDrawer from "@mui/material/Drawer";

const drawerWidth = "100%";

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: open ? drawerWidth : theme.spacing("70px"),
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    margin: 0,
    boxSizing: "border-box",
    backgroundColor: "#f4f6fb",
    boxShadow: "2px 0 8px rgba(0, 0, 0, 0.1)",
    overflowX: "hidden",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      width: open ? drawerWidth : 0,
    },
  },
}));

export default function Sidebar({ isMobile }) {
  const [openMenu, setOpenMenu] = useState(()=> isMobile);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  const handleOpenLogout = () => setOpenLogoutDialog(true);
  const handleCloseLogout = () => setOpenLogoutDialog(false);

  const handleConfirmLogout = () => {
    setOpenLogoutDialog(false);

    window.location.href = "/login";
  };

// Se o breakpoint mobile mudar, atualiza o estado
 useEffect(() => {
    setOpenMenu(!isMobile);
  }, [isMobile]);

  const toggleDrawerMenu = () => {
   setOpenMenu((prev) => !prev);
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Box sx={{ height: "100%" }}>
        <Drawer
          variant="permanent"
          open={openMenu}
          style={{ height: "100%", overflowY: "auto" }}
        >
          <List component="nav" sx={{ paddingInline: "5px" }}>
            {mainListItems}

            <Divider sx={{ my: 1, backgroundColor: "#d0d4e4", height: "1px" }} />

            {moreListItems}

            <Divider sx={{ my: 1, backgroundColor: "#d0d4e4", height: "1px" }} />

            {/* sairListItems chama o Dialog */}
            {sairListItems(handleOpenLogout)}
          </List>
        </Drawer>
      </Box>

      {/* Botão do menu */}
      <Fab
        size="small"
        color="primary"
        aria-label="add"
        onClick={toggleDrawerMenu}
        sx={{
          position: "absolute",
          top: 20,
          left: openMenu ? 250 : isMobile ? 0 : 90,
          zIndex: 1300,
          backgroundColor: "#1A3865",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#1A3865",
          },
        }}
      >
        {openMenu ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </Fab>

      {/*  Dialog de confirmação de saída */}
      <Dialog open={openLogoutDialog} onClose={handleCloseLogout}>
        <DialogTitle>Deseja sair do sistema?</DialogTitle>

        <DialogContent>
          Caso você confirme, voltará para a tela de identificação.
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseLogout}>Cancelar</Button>
          <Button onClick={handleConfirmLogout}>Sair</Button>
        </DialogActions>

      </Dialog>
    </Box>
  );
}

Sidebar.propTypes = {
  isMobile: PropTypes.bool,
};
